import {clickBuryingPoint} from '@/api'
export default {
  install(Vue, options) {
    //当前页面module_int
    Vue.prototype.current_page_module_int = '';
    //菜单埋点
    Vue.prototype.menuBuryingPoint = function(module_int){
      //存储当前菜单数据
      this.current_page_module_int=module_int
      localStorage.setItem('current_page_module_int',module_int)
      this.buryingPoint()
    }
    //埋点
    Vue.prototype.buryingPoint = function(module_int,name) {
      /*
      * module_int:当前按钮的module_int
      * name:当前按钮的名称
      * */

      let current_page_module_int=localStorage.getItem('current_page_module_int')
      console.log(current_page_module_int);
      if(!current_page_module_int||current_page_module_int==''){
        return;
      }
      let menu_name=this.$store.state.buryingPoint[current_page_module_int]

      console.log(menu_name);
      let params={
        module_int:module_int
      }
      if(module_int==undefined){
        params.module_int=current_page_module_int
      }
      if(menu_name[0]){
        params.level_one=menu_name[0]
      }
      if(menu_name[1]){
        params.level_two=menu_name[1]
      }
      if(menu_name[2]){
        params.level_three=menu_name[2]
      }
      if(menu_name[3]){
        params.level_four=menu_name[3]+(name?'-'+name:'')
      }
      console.log(params);
      clickBuryingPoint(params).then((res)=>{

      })
    }
    //埋点 点击顶部
    Vue.prototype.buryingPointTop =function(module_int) {

      let menu_name=this.$store.state.buryingPoint[module_int]

      console.log(menu_name);
      let params={
        module_int:module_int
      }
      if(module_int==undefined){
        params.module_int=current_page_module_int
      }
      if(menu_name[0]){
        params.level_one=menu_name[0]
      }
      if(menu_name[1]){
        params.level_two=menu_name[1]
      }
      if(menu_name[2]){
        params.level_three=menu_name[2]
      }
      if(menu_name[3]){
        params.level_four=menu_name[3]+(name?'-'+name:'')
      }
      console.log(params);
      clickBuryingPoint(params).then((res)=>{

      })
    }
  }
}